

<div class="banner-encabezado">
   <div class="banner-texto">
    <span class="banner-badge" *ngIf="badgeText">{{ badgeText }}</span>
    <h3 class="banner-titulo">{{ titulo }}</h3>
    <p class="banner-proceso" *ngIf="procesoActual">Proceso: {{ procesoActual }}</p>
    <p class="banner-descripcion" *ngIf="descripcion">{{ descripcion }}</p>
  </div>

  <div class="banner-dinamico" *ngIf="mostrarContador && contador !== null && contador !== undefined && contador !== ''">
    <div class="banner-contador">
      
      <div 
        *ngIf="mostrarIndicador" 
        class="status-indicator" 
        [ngClass]="indicadorActivo ? 'activo' : 'inactivo'">
      </div>

      <span class="contador-numero">{{ contador }}</span>
      <span class="contador-label">{{ contadorLabel }}</span>
    </div>
  </div>

  <div class="banner-dinamico" *ngIf="!mostrarContador || contador === null || contador === undefined || contador === ''">
    <ng-content select="[banner-derecho]"></ng-content>
  </div>
</div>



<!-- 
================           METODOS DE USO               =======================
================Flujo normaal sin estado activo/inactivo========================
<app-encabezado
  badgeText="Admisiones"
  titulo="Comisiones"
  descripcion="Administre las comisiones registradas para el proceso de admisión de posgrado."
  contadorLabel="Comisiones"
  [contador]="25"> </app-encabezado>
  
  
  
  
  ================Flujo con estado activo/inactivo========================
  <app-encabezado
  badgeText="Admisiones"
  [titulo]="esEdicion ? 'Editar Proceso de Admisión' : 'Nuevo Proceso de Admisión'"
  descripcion="Configure la información general del proceso de admisión. Posteriormente podrá agregar las carreras participantes y sus requisitos."
  contadorLabel="Estado"
  [contador]="procesoForm.value.estado ? 'Activo' : 'Borrador'"
  [mostrarIndicador]="true"
  [indicadorActivo]="procesoForm.value.estado">
</app-encabezado>
  
  
  
  -->